import { EBetslipType } from 'interfaces/betslip';

export type TBetslipStaticConfigs = {
  betslipFixedHeight: boolean;
  floatingMode: boolean;
  betslipRootId: string;
};
export type TBetslipComputedConfigs = {
  isOpened: boolean;
  mustOpen: boolean;
  mustClose: boolean;
  betslipType: EBetslipType;
};

export enum EBetslipConfigsDispatchActions {
  SET_STATIC_CONFIGS = 'SET_STATIC_CONFIGS',
  /*Toggle States start*/
  SET_IS_OPENED = 'SET_IS_OPENED',
  SET_MUST_OPEN = 'SET_MUST_OPEN',
  SET_MUST_CLOSE = 'SET_MUST_CLOSE',
  /*Toggle States end*/

  SET_BETSLIP_TYPE = 'SET_BETSLIP_TYPE'
}
